var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIBene3Cp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-86c02c31-8000-40b7-9ab9-c8444ac90738",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#4a46ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-18c49735-aba2-48ce-8a8b-55499b9e4c9f",
    d: "M63.35,25.35h-14c-.53,0-1.04.21-1.41.59l-22,22c-.78.78-.78,2.05,0,2.83l14,14c.39.39.9.59,1.41.59s1.02-.2,1.41-.59l22-22c.37-.37.59-.88.59-1.41v-14c0-1.11-.89-2-2-2ZM58.76,34.76l-2,2c-.39.39-.9.59-1.41.59s-1.02-.2-1.41-.59c-.78-.78-.78-2.05,0-2.83l2-2c.78-.78,2.05-.78,2.83,0s.78,2.05,0,2.83Z",
    fill: "#4a46ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBene3Cp);
export default __webpack_public_path__ + "static/media/I-Bene3-CP.1123d58cfcb9b233a4622425d6de3d95.svg";
export { ForwardRef as ReactComponent };